import React from "react";
import { useHistory } from "react-router-dom";
import "./PrivacyPage.css";

const PrivacyPage = () => {
  const history = useHistory();
  const onHide = () => {
    history.goBack();
  };
  return (
    <main className="privacy-page">
      <div className="privacy-page__shell">
        <header className="privacy-page__header">
          <div>
            <span className="privacy-page__eyebrow">KHUB legal</span>
            <h1>Privacy Policy</h1>
            <p>How we collect, use, and protect your information.</p>
          </div>
        <button
          type="button"
            onClick={onHide}
            className="privacy-page__back-button"
            aria-label="Go back to the previous page"
        >
            <span aria-hidden="true">&#8592;</span> Back
        </button>
        </header>

        <article className="privacy-page__card">
          <div className="privacy-page__intro">
            <h2>Welcome to KHUB!</h2>
            <p>This Privacy Policy governs your use of KHUB. We respect your privacy and are committed to protecting your personal information.</p>
          </div>
          <section className="privacy-page__section">
          <p className="privacy_p">1. Information We Collect</p>
          <ul>
            <li>
              Personal Identification Information: This includes, but is not limited to, your full name, email address, and contact number, required for login
              and support purposes.
            </li>
            <li>Usage Data: We collect data related to your interactions with the product, such as order creation and fulfillment.</li>
            <li>
              Device Information: We may collect information about the device you use to access our product, including the hardware model and operating system.
            </li>
          </ul>
          </section>
          <section className="privacy-page__section">
          <p className="privacy_p">2. How We Use Your Information</p>
          <p>We use the collected information for various purposes:</p>
          <ul>
            <li>To provide and maintain our services</li>
            <li>To improve the functionality of our services.</li>
            <li>To provide customer support.</li>
            <li>To gather analysis or valuable information to improve our product.</li>
            <li>To detect, prevent, and address technical issues.</li>
          </ul>
          </section>
          <section className="privacy-page__section">
          <p className="privacy_p">3. Disclosure Of Data</p>
          <p>
            We do not share your personal information with third parties, except when required to provide and improve the service, or when legally obligated to
            do so.
          </p>
          </section>
          <section className="privacy-page__section">
          <p className="privacy_p">4. Security Of Data</p>
          <p>
            We prioritize the security of your data. We implement robust security measures to protect your personal information from unauthorized access,
            alteration, disclosure, or destruction. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.
          </p>
          </section>
          <section className="privacy-page__section privacy-page__section--location">
          <p className="privacy_p">5. Location Information</p>
          <p>Our Delivery App collects and uses your location information to provide delivery-related services.</p>
          <p className="privacy_p privacy-page__subheading">
            <span>5.1</span> What Location Data We Collect
          </p>
          <p>We may collect:</p>
          <ul>
            <li>Precise location (GPS) while the app is in use.</li>
            <li>
              Background location, when required during an active delivery, to continue tracking delivery progress even if the app is minimized or the device
              screen is off.
            </li>
          </ul>
          <p className="privacy_p privacy-page__subheading">
            <span>5.2</span> Why We Collect Location Data
          </p>
          <p>Location information is used to:</p>
          <ul>
            <li>Navigate drivers to pickup and delivery locations.</li>
            <li>Track delivery progress during active deliveries.</li>
            <li>Update delivery status.</li>
            <li>Verify completed deliveries.</li>
            <li>Improve delivery accuracy and operational efficiency.</li>
          </ul>
          <p className="privacy_p privacy-page__subheading">
            <span>5.3</span> How Location Data Is Collected
          </p>
          <p>
            Location data is collected only after you grant the required permissions. Background location is used only while an active delivery is in progress
            and only for features that require continuous location updates.
          </p>
          <p className="privacy_p privacy-page__subheading">
            <span>5.4</span> Sharing Of Location Data
          </p>
          <p>
            Location information may be shared with authorized administrators, merchants, or customers only as necessary to provide delivery tracking and
            complete delivery services. We do not sell your location data to third parties.
          </p>
          <p className="privacy_p privacy-page__subheading">
            <span>5.5</span> Location Data Security
          </p>
          <p>We use reasonable administrative and technical safeguards to protect your location information during transmission and storage.</p>
          <p className="privacy_p privacy-page__subheading">
            <span>5.6</span> Your Choices
          </p>
          <p>
            You can manage or revoke location permissions at any time through your device settings. Please note that disabling location permissions may prevent
            certain delivery features from functioning correctly.
          </p>
          </section>
          <section className="privacy-page__section">
          <p className="privacy_p">6. Changes To This Privacy Policy</p>
          <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
          </section>
          <section className="privacy-page__section">
          <p className="privacy_p">7. Contact Us</p>
          <p>
            If you have any questions about this Privacy Policy or our handling of your personal information, please contact us at:{" "}
            <a href="mailto:info@khub.biz">info@khub.biz</a>
          </p>
          </section>
          <section className="privacy-page__section">
          <p className="privacy_p">8. Consent</p>
          <p>By using KHUB, you consent to our Privacy Policy and agree to its terms. If you do not agree with our policies, please do not use KHUB.</p>
          </section>
        </article>
      </div>
    </main>
  );
};

export default PrivacyPage;
